import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendDeleteRequestApi } from "../../../services/service";

const initialState = {
  data: {},
  status: "idle",
  loading: false,
  error: "",
};

// Define the async thunk for applying for a job
export const deleteMcq = createAsyncThunk("deleteMcq", async ({id}) => {
  try {
    const response = await  sendDeleteRequestApi(`/mcq/${id}`);
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
});

export const deleteCoding = createAsyncThunk("deleteCoding", async ({id}) => {
    try {
      const response = await  sendDeleteRequestApi(`/coding/${id}`);
      return response;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  });

  export const deleteBehavioural = createAsyncThunk("deleteBehavioural", async ({id}) => {
    try {
      const response = await  sendDeleteRequestApi(`/behavior/${id}`);
      return response;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  });

const deleteApiSlice = createSlice({
  name: "deleteApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteMcq.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteMcq.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.deleteMcqData = action.payload;
      })

      .addCase(deleteMcq.rejected, (state, action) => {
        state.status = "idle";
        state.data.deleteMcqData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })

      .addCase(deleteCoding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteCoding.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.deleteCodingData = action.payload;
      })

      .addCase(deleteCoding.rejected, (state, action) => {
        state.status = "idle";
        state.data.deleteCodingData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })


      .addCase(deleteBehavioural.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteBehavioural.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.deleteBehaviouralData = action.payload;
      })

      .addCase(deleteBehavioural.rejected, (state, action) => {
        state.status = "idle";
        state.data.deleteBehaviouralData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })
  },
});

export default deleteApiSlice.reducer;
